// Copyright (c) 2024-2026 Echonum LLC. All rights reserved.
// Product: Exploit Score ETS (Exploit Threat Score)
// Version: 2.0.4
//
// This file is part of Exploit Score ETS, proprietary software developed by
// Echonum LLC. Unauthorized copying, distribution, modification, or use of
// this file, via any medium, is strictly prohibited without express written
// permission from Echonum LLC.
//
// Confidential and Proprietary.

import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  CreditCard,
  Key,
  Download,
  MessageSquare,
  Settings,
  Building2
} from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

const customerNav = [
  { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/billing', icon: CreditCard, label: 'Billing' },
  { path: '/licenses', icon: Key, label: 'Licenses' },
  { path: '/downloads', icon: Download, label: 'Downloads' },
  { path: '/support', icon: MessageSquare, label: 'Support' },
  { path: '/account', icon: Settings, label: 'Account' },
]

const mspNav = [
  { path: '/msp', icon: Building2, label: 'Customer Fleet' },
  { path: '/msp/support', icon: MessageSquare, label: 'Customer Tickets' },
  { path: '/account', icon: Settings, label: 'Account' },
]

export default function Sidebar() {
  const { user } = useAuth()
  const navItems = user?.role === 'msp' ? mspNav : customerNav
  return (
    <aside className="w-64 bg-dark-card border-r border-dark-border flex flex-col">
      {/* Logo */}
      <div className="h-16 flex items-center px-6 border-b border-dark-border">
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="Exploit Score" className="h-10 w-auto" />
          <span className="text-lg font-semibold">Exploit Score</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-primary-500/10 text-primary-500'
                  : 'text-gray-400 hover:bg-gray-800 hover:text-white'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-dark-border">
        <div className="text-xs text-gray-500">
          <p>Customer Portal v1.0</p>
          <p>&copy; 2025 Exploit Score</p>
        </div>
      </div>
    </aside>
  )
}
